import React, { FC } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTaskSlice } from '../../slice';
import {
  selectTaskDetailsState,
  selectTaskResourcesState,
} from '../../slice/selectors';
import { ITaskUsedResource } from '../../slice/types';
import TaskResourcesTable from '../TaskResourcesTable/TaskResourcesTable';

interface IProps {}

const TaskUsedResourcesTable: FC<IProps> = () => {
  const dispatch = useDispatch();

  const { actions } = useTaskSlice();

  const { task } = useSelector(selectTaskDetailsState);
  const {
    usedResources: { updatedResourcesArr },
  } = useSelector(selectTaskResourcesState);
  const onDeleteUsedResourceClick = (resource: ITaskUsedResource) => {
    dispatch(actions.toggleTaskUsedResource(resource));
  };

  const onNormChange = (resourceId: number, norm: number) => {
    dispatch(
      actions.updateTaskUsedResourceNorm({
        resourceId,
        norm,
      }),
    );
  };

  return (
    <TaskResourcesTable
      showFieldNames={true}
      loading={false}
      isEditable={false}
      taskCategoryName={task?.category.name}
      resourcesArr={updatedResourcesArr}
      onDeleteClick={onDeleteUsedResourceClick}
      onNormChange={onNormChange}
    />
  );
};

export default TaskUsedResourcesTable;
